import { FaqHelper } from "../FaqHelper/faq_helper";

export const initPrismicPage = () => {
  document.querySelectorAll<HTMLElement>(".js-history-back").forEach((button) => {
    if (button.dataset.historyBackInitialized) {
      return;
    }

    button.addEventListener("click", (event) => {
      event.preventDefault();
      window.history.back();
    });
    button.dataset.historyBackInitialized = "true";
  });

  const faqMarker = document.querySelector<HTMLElement>("[data-faq-scroll]");
  if (faqMarker && !faqMarker.dataset.faqScrollInitialized) {
    FaqHelper.init();
    faqMarker.dataset.faqScrollInitialized = "true";
  }

  document.querySelectorAll<HTMLElement>("[data-anchor-link-panel]").forEach((alphabetScroll) => {
    if (alphabetScroll.dataset.anchorLinksInitialized) {
      return;
    }

    // find parent sidebar container then query for sidebar body
    const contentEl = alphabetScroll.closest("[data-content-sidebar-container]")
      ?.querySelector("[data-content-sidebar-body]");
    if (!contentEl) {
      return;
    }
    const anchors = Array.from(contentEl.querySelectorAll<HTMLAnchorElement>("a[name]"))
      .map((el) => el.name);

    anchors.forEach((anchor) => {
      const spanEl = document.createElement("span");
      // apply classes, if a link is longer than one character, set it to full width
      spanEl.classList.add("anchor_link__cell");
      if (anchor.length > 1) {
        spanEl.classList.add("anchor_link__cell--full");
      }
      // create link
      const linkEl = document.createElement("a");
      linkEl.href = `#${anchor}`;
      anchor.split("__").forEach((line, index) => {
        if (index > 0) {
          linkEl.appendChild(document.createElement("br"));
        }
        linkEl.appendChild(document.createTextNode(line.replace(/_/g, " ")));
      });
      // appendage
      spanEl.appendChild(linkEl);
      alphabetScroll.appendChild(spanEl);
    });

    alphabetScroll.dataset.anchorLinksInitialized = "true";
  });
};
